import { render, staticRenderFns } from "./RegistrationDropdown.vue?vue&type=template&id=142bd609&"
import script from "./RegistrationDropdown.vue?vue&type=script&lang=ts&"
export * from "./RegistrationDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports